const listRouteMixin = {
  methods: {
    onSorted (sorted) {
      const ordering = `${ sorted.ascending ? "" : "-" }${ sorted.column }`
      this.$router.replace({ query: { ...this.$route.query, ordering } })
    },
    onPagination (page) {
      const { name, params, query } = this.$route
      // ideally we shouldn't pass context in params
      // this hack is done here to prevent duplicate api requests
      // should be revisited when a proper fix is found
      params.paginated = true
      this.options.previousPage = page
      this.$router.push({ name, params, query: { ...query, page } })
    },
  },
  watch: {
    $route (to) {
      if (!to.params.paginated) this.getData()
    },
  },
}

export { listRouteMixin }
